// extracted by css-extract-rspack-plugin
export default {"pointer":"pointer-uZ9jlS","message":"message-qSgkmx"};